const QuestionFieldTypes = {
  TEXTBOX: "TEXTBOX",
  RADIO_BUTTON: "RADIO BUTTON",
  CHECKBOX: "CHECKBOX",
  DROPDOWN: "DROPDOWN",
  COUNTRY: "COUNTRY",
};

export default Object.freeze(QuestionFieldTypes);
